<template>
  <!--抽屉-->
  <transition v-if="drawerStatus">
    <div class="drawer">
      <div class="fixed-bg" @click.stop="close"></div>
      <div class="drawer-box">
        <slot name="title"></slot>
        <div class="drawer-con">
          <el-scrollbar style="height: 100%; overflow-x: hidden">
            <slot name="content"></slot>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    drawerStatus: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss">
.drawer {
  position: fixed;
  top: 60px;
  left: 0;
  z-index: 2000;
  @include wh(100vw, 100vh);
  display: flex;
}
.fixed-bg {
  background: rgba(0, 0, 0, 0.01);
  flex: 1;
}
.drawer-box {
  @include wh(300px, 100vh);
  background: #f3f3f3;
  padding: 24px 14px;
  float: right;
  box-shadow: -3px 0px 6px 0px rgba(0, 0, 0, 0.03);
  .draw-title {
    h3 {
      font-size: 16px;
      color: #3b3946;
      margin-bottom: 14px;
    }
    > p {
      font-size: 12px;
      color: #999;
    }
  }

  .drawer-con {
    margin-top: 24px;
    height: 100%;
  }
}
</style>
